import React, {useCallback} from 'react'
import {useDispatch,useSelector,shallowEqual} from 'react-redux'
import {withRouter} from 'react-router-dom'
import PropTypes from 'prop-types'
import SearchDomain from '../../searchdomain'
import CloseButton from '../../closebutton'
import SelectButtonDomain from "../selectbutton/domain";
import Tab from '../../tabs'

import { getDataFromURL } from '../../../../utilities/function/urlparams'
import { updateConfig } from '../../../../app/action'




let SelectDomain =  (props) => {
  const {location,history} = props
  const getIsNewDomainName = () =>{
    const {domain} = getDataFromURL(location.search)
    if(domain==='register'){
      return true
    }
    if(domain==='transfer'){
      return false
    }
    return true
  }
  const dispatch = useDispatch()
  const configurations = useSelector(state=>state.app.configurations,shallowEqual)
  const searchItemCallback = useCallback((step,domainconfig)=>{
    const selected = domainconfig
    if(selected && selected.domainSearchResult){
      const {domain,tld} = selected.domainSearchResult
      const cid = domain+tld
      const currentConfig = configurations[cid]
      if(currentConfig){
        updateConfig(configurations,cid,{
          ...currentConfig,
          ...selected
        },dispatch)
      }else{
        updateConfig(configurations,cid,{
          ...selected
        },dispatch)
      }
    }
  },[dispatch,configurations])
  const searchFormSubmitCallback = useCallback((value, isTransferMode, isNewDomainName)=>{
    console.log(value, isTransferMode, isNewDomainName)
  },[])
  const searchDomainInit = useCallback((setIsTransferMode,searchFieldEl)=>{
    const {domain} = getDataFromURL(location.search)
    if(domain==='register'){
      setIsTransferMode(false)
    }else if(domain==='transfer'){
      setIsTransferMode(true)

    }else{
      setIsTransferMode(false)
    }
    searchFieldEl.current.value=""
  },[location])

  const isTransferPage = () =>{
    const {domain} = getDataFromURL(location.search)
    if(domain==='transfer'){
      return true
    }
    return false
  }

  const {domain,query,a,promo} = getDataFromURL(location.search)
  const promoParams = promo?`&promo=${promo}`:''
  return (
    <div className='of-select-domain of-step'>
      <div className={'clear'} />
      <div className={'of-select-domain__wrapper'}>
        <Tab
          className={'of-select-domain__tab'}
          list={[
            {
              label: 'Register Domain',
              onClick: ()=>{
                history.push(`${window.location.pathname}?a=${a}&domain=${'register'}&query=${query}${promoParams}`)
              }
            },
            {
              label: 'Transfer Domain',
              onClick: ()=>{
                history.push(`${window.location.pathname}?a=${a}&domain=${'transfer'}&query=${query}${promoParams}`)
              }
            }
          ]}
          init={setSelected=>{
            if(domain==='transfer'){
              setSelected(1)
            }else{
              setSelected(0)
            }
          }}
        />
        <SearchDomain
          onSubmit={searchFormSubmitCallback}
          searchItemCallback={searchItemCallback}
          className='of-select-domain__searchdomain'
          isNewDomainName={getIsNewDomainName()}
          init={searchDomainInit}
          isTransferPage={isTransferPage()}
        />
        <SelectButtonDomain className={'of-select-domain__button'} />
      </div>
      <CloseButton />
    </div>
  )
}

SelectDomain.propTypes = {
  location : PropTypes.any,
  history : PropTypes.any
}

SelectDomain = withRouter(SelectDomain)

export default SelectDomain
